import { useSite } from "@/context/SiteContext";
import { SITE_NAME } from "@/constants/site";

const DEFAULT_LOGO = "/bondstein-logo.png";

const PRODUCT_LABEL = {
  nav: "inline font-mono-ui uppercase text-neutral-500 border-l border-neutral-300 pl-2 min-w-0 text-[7px] tracking-[0.1em] leading-snug max-md:max-w-[120px] max-md:line-clamp-3 sm:text-[9px] sm:tracking-[0.14em] sm:pl-2.5 md:max-w-none md:whitespace-nowrap",
  footer:
    "inline font-mono-ui uppercase text-neutral-500 border-l border-neutral-300 pl-2 min-w-0 text-[7px] tracking-[0.1em] max-w-[120px] line-clamp-3 leading-snug sm:text-[9px] sm:tracking-[0.14em] sm:max-w-[240px] md:max-w-[320px] lg:max-w-[420px] sm:pl-2.5",
};

// Bondstein logo used in Nav + Footer. CMS-uploaded logo overrides when set in Admin.
export const Logo = ({ size = "md", showProduct = true, context = "footer" }) => {
  const { settings } = useSite();
  const logo = settings?.logo_url || settings?.logo_data || DEFAULT_LOGO;
  const brand = settings?.brand_name || "Bondstein";
  const product = settings?.product_name || SITE_NAME;

  const heights = { sm: "h-6", md: "h-7", lg: "h-9" };
  const heightCls = heights[size] || heights.md;
  const labelCls = PRODUCT_LABEL[context] || PRODUCT_LABEL.footer;

  return (
    <div className="flex items-center gap-2 min-w-0" data-testid="brand-logo" data-nav-brand="image">
      <img
        src={logo}
        alt={brand}
        data-testid="nav-brand"
        className={`${heightCls} w-auto shrink-0 object-contain`}
      />
      {showProduct && (
        <span className={labelCls}>
          {product}
        </span>
      )}
    </div>
  );
};
